import React, { useState } from "react";
import { Link } from "react-router-dom";

function Header() {
  const [openbtn1Click, setOpenbtn1Click] = useState(false);

  return (
    <header id="header">
      <h1>
        <Link
          to={
            process.env.REACT_APP_ENVIRONMENT === "main"
              ? "http://01kumamoto.0147.jp/"
              : "http://stg.01kumamoto.0147.jp/"
          }
          title=""
        >
          <img
            src={process.env.PUBLIC_URL + "/assets/images/common/logo.svg"}
            alt=""
          />
        </Link>
      </h1>

      <div id="g-nav-list" className="visible_pc">
        <ul className="nav">
          <li>
            <Link
              to={
                process.env.REACT_APP_ENVIRONMENT === "main"
                  ? "http://01kumamoto.0147.jp/"
                  : "http://stg.01kumamoto.0147.jp/"
              }
              title=""
            >
              Top
            </Link>
          </li>
          <li>
            <Link
              to={
                process.env.REACT_APP_ENVIRONMENT === "main"
                  ? "http://01kumamoto.0147.jp/projects/"
                  : "http://stg.01kumamoto.0147.jp/projects/"
              }
              title=""
            >
              プロジェクト一覧
            </Link>
          </li>
          <li>
            <Link
              to={
                process.env.REACT_APP_ENVIRONMENT === "main"
                  ? "http://01kumamoto.0147.jp/process/"
                  : "http://stg.01kumamoto.0147.jp/process/"
              }
              title=""
            >
              応募方法
            </Link>
          </li>
          <li>
            <Link
              to={
                process.env.REACT_APP_ENVIRONMENT === "main"
                  ? "http://01kumamoto.0147.jp/event/"
                  : "http://stg.01kumamoto.0147.jp/event/"
              }
              title=""
            >
              説明会
            </Link>
          </li>
          <li class="link">
            <Link
              to={"https://forms.gle/ebaVcstaHMZYRF3h6"}
              title=""
              target={"_blank"}
            >
              お問い合わせ
            </Link>
          </li>
        </ul>

        <ul className="btn-nav">
          <li className="link-btn01">
            <Link
              to={
                process.env.REACT_APP_ENVIRONMENT === "main"
                  ? "http://01kumamoto.0147.jp/event/"
                  : "http://stg.01kumamoto.0147.jp/event/"
              }
              title=""
            >
              説明会・イベント
            </Link>
          </li>
          <li className="link-btn02">
            {process.env.REACT_APP_ENVIRONMENT === "main" ? (
              <Link to="http://0147.jp" target={"_blank"}>
                応募サイト
                <br />
                ゼロイチ47
              </Link>
            ) : (
              <Link to="http://stg.0147.jp" target={"_blank"}>
                応募サイト
                <br />
                ゼロイチ47
              </Link>
            )}
          </li>
        </ul>
      </div>

      <div
        className={`openbtn1 visible_sp ${openbtn1Click ? "active" : ""}`}
        onClick={() => {
          setOpenbtn1Click(!openbtn1Click);
        }}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <nav
        id="g-nav"
        className={`visible_sp ${openbtn1Click ? "panelactive" : ""}`}
      >
        <div id="g-nav-list " className="visible_sp">
          <ul>
            <li>
              <Link
                to={
                  process.env.REACT_APP_ENVIRONMENT === "main"
                    ? "http://01kumamoto.0147.jp/"
                    : "http://stg.01kumamoto.0147.jp/"
                }
                title=""
              >
                Top
              </Link>
            </li>
            <li>
              <Link
                to={
                  process.env.REACT_APP_ENVIRONMENT === "main"
                    ? "http://01kumamoto.0147.jp/projects/"
                    : "http://stg.01kumamoto.0147.jp/projects/"
                }
                title=""
              >
                プロジェクト一覧
              </Link>
            </li>
            <li>
              <Link
                to={
                  process.env.REACT_APP_ENVIRONMENT === "main"
                    ? "http://01kumamoto.0147.jp/process/"
                    : "http://stg.01kumamoto.0147.jp/process/"
                }
                title=""
              >
                応募方法
              </Link>
            </li>
            <li>
              <Link
                to={
                  process.env.REACT_APP_ENVIRONMENT === "main"
                    ? "http://01kumamoto.0147.jp/event/"
                    : "http://stg.01kumamoto.0147.jp/event/"
                }
                title=""
              >
                説明会
              </Link>
            </li>

            <li class="link">
              <Link
                to={"https://forms.gle/ebaVcstaHMZYRF3h6"}
                title=""
                target={"_blank"}
              >
                お問い合わせ
              </Link>
            </li>

            <li className="link-btn01">
              <Link
                to={
                  process.env.REACT_APP_ENVIRONMENT === "main"
                    ? "http://01kumamoto.0147.jp/event/"
                    : "http://stg.01kumamoto.0147.jp/event/"
                }
                title=""
              >
                説明会・イベント
              </Link>
            </li>
            <li className="link-btn02">
              {process.env.REACT_APP_ENVIRONMENT === "main" ? (
                <Link to="http://0147.jp" target={"_blank"}>
                  応募サイト
                  <br />
                  ゼロイチ47
                </Link>
              ) : (
                <Link to="http://stg.0147.jp" target={"_blank"}>
                  応募サイト
                  <br />
                  ゼロイチ47
                </Link>
              )}
            </li>
          </ul>
        </div>
      </nav>
      <div
        className={
          "circle-bg " +
          "visible_sp " +
          ` ${openbtn1Click ? "circleactive" : ""}`
        }
      ></div>
    </header>
  );
}

export default Header;
